class ProductMain extends HTMLElement {
  constructor() {
    super();
    
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.errorWrapper = this.querySelector('.product-form-cart-error')

    this.accordions = this.querySelectorAll('[accordion-title]')
    this.modalTrigger = this.querySelector('[modal-trigger]')
    this.upsellSwitch = this.querySelector('[product-upsell-switch]')

    this.dogSizes = this.querySelectorAll('[product-dog-size]')
    this.tabs = this.querySelectorAll('[product-main__tab-options]')
    this.sellPlans = this.querySelectorAll('[product-sell-plan]')
    this.onetimes = this.querySelectorAll('[product-one-time-order]')

    this.upsellPlans = this.querySelectorAll('[upsell-plan]')
    
    // Find first available dog size
    const firstAvailableDogSize = Array.from(this.dogSizes).find(
      dogSize => dogSize.getAttribute('data-all-sold-out') === "false"
    );
    
    if (firstAvailableDogSize) {
      this.dog_size = firstAvailableDogSize.getAttribute('data-id');
      
      // Find first available sell plan for this dog size
      const firstAvailableSellPlan = Array.from(this.sellPlans).find(
        sellPlan => sellPlan.getAttribute('data-parent-id') === this.dog_size && !sellPlan.classList.contains('hidden')
      );
      
      if (firstAvailableSellPlan) {
        this.sell_plan = firstAvailableSellPlan;
      } else {
        this.sell_plan = this.sellPlans[0]; // Fallback
      }
      
      // Find first available one-time option for this dog size
      const firstAvailableOneTime = Array.from(this.onetimes).find(
        oneTime => {
          return oneTime.getAttribute('data-parent-id') === this.dog_size && 
                 oneTime.getAttribute('data-variant-available') === "true";
        }
      );
      
      if (firstAvailableOneTime) {
        this.onetime = firstAvailableOneTime;
      } else {
        this.onetime = this.onetimes[0]; // Fallback
      }
    } else {
      // Fallback if no available dog size
      this.dog_size = this.dogSizes[0]?.getAttribute('data-id') || '';
      this.sell_plan = this.sellPlans[0];
      this.onetime = this.onetimes[0];
    }

    this.addToCartCTA = this.querySelector('[add-to-cart]')

    this.onClickTitle = this.onClickAccordion.bind(this)
    this.onModalTrigger = this.onModalTrigger.bind(this)
    this.onClickDogSize = this.onClickDogSize.bind(this)
    this.onClickSellPlan = this.onClickSellPlan.bind(this)
    this.updateSellPlans = this.updateSellPlans.bind(this)
    this.updateFormField = this.updateFormField.bind(this)
    this.onClickTab = this.onClickTab.bind(this)
    this.updateOnetime = this.updateOnetime.bind(this)
    this.onClickOneTimeVariant = this.onClickOneTimeVariant.bind(this)
    this.updateTotalPrice = this.updateTotalPrice.bind(this);
    this.updateUpsellForActiveTab = this.updateUpsellForActiveTab.bind(this);
  }

  connectedCallback() {
    this.accordions.forEach(item => {
      item.addEventListener('click', () => {
        this.onClickAccordion(item)
      }, false)
    })
    this.modalTrigger.addEventListener('click', this.onModalTrigger)

    this.dogSizes.forEach(item => {
      item.addEventListener('click', () => {
        this.onClickDogSize(item)
      }, false)
    })

    this.tabs.forEach(item => {
      item.addEventListener('click', () => {
        this.onClickTab(item)
      }, false)
    })

    this.sellPlans.forEach(item => {
      item.addEventListener('click', () => {
        this.onClickSellPlan(item)
      }, false)
    })

    this.onetimes.forEach(item => {
      item.addEventListener('click', () => {
        this.onClickOneTimeVariant(item)
      }, false)
    })

    // Only add upsell switch listener if it exists
    if (this.upsellSwitch) {
      this.upsellSwitch.addEventListener('click', this.onClickUpsellSwitch.bind(this))
    }

    this.addToCartCTA.addEventListener('click', this.onClickAddToCart.bind(this))

    this.onClickSellPlan(this.sell_plan)

    this.updateTotalPrice();
  }

  onClickAddToCart() {
    const payload = []
    let id = this.querySelector('[name="id"]').value
    let sell_plan_id = this.querySelector('[name="selling_plan"]').value
    if(sell_plan_id) {
      payload.push({
        id,
        quantity: 1,
        selling_plan: sell_plan_id
      })
    } else {
      payload.push({
        id,
        quantity: 1
      })
    }

    // Upsell - only process if upsell switch exists and is active
    if(this.upsellSwitch && this.upsellSwitch.classList.contains('upsell-switch-active')) {
      const upsellPlan = this.querySelector('[upsell-plan]:not(.hidden)');
      if (upsellPlan) {
        id = upsellPlan.getAttribute('data-variant-id') || '';
        const alwaysOneTime = upsellPlan.getAttribute('data-always-one-time') === 'true';

        if (id) {
          // Only add the selling plan if it's not set to always be one-time
          if (!alwaysOneTime) {
            sell_plan_id = upsellPlan.getAttribute('data-plan-id') || '';

            if(sell_plan_id) {
              payload.push({
                id,
                quantity: 1,
                selling_plan: sell_plan_id
              });
            } else {
              payload.push({
                id,
                quantity: 1
              });
            }
          } else {
            // Always add as one-time purchase
            payload.push({
              id,
              quantity: 1
            });
          }
        }
      }
    }

    const formData = {
      items: payload
    }

    if (this.cart) {
      formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id).join(',')

      // formData['sections_url'] = window.location.pathname
      this.cart.setActiveElement(document.activeElement)
    }
    
    fetch(`${window.routes.cart_add_url}.js`, {
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.errorWrapper.innerHTML = response.description
        return
      }
      this.errorWrapper.innerHTML = ''
      this.cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    });
  }

  onClickDogSize(item) {
    this.dog_size = item.getAttribute('data-id')
    this.dogSizes.forEach(dogSize => {
      let btn = dogSize.querySelector('[role="button"]')
      if(dogSize === item) {
        dogSize.setAttribute('aria-selected', true)
        dogSize.setAttribute('data-state', 'active')
        btn.classList.add('active')

        // Update the appropriate options based on the current tab
        if (!this.tabId || this.tabId === 'subscription') {
          this.updateSellPlans()
        } else {
          this.updateOnetime(true)
        }
      } else {
        dogSize.setAttribute('aria-selected', false)
        dogSize.setAttribute('data-state', 'inactive')
        btn.classList.remove('active')
      }
    })
    this.updateTotalPrice()
    
    // Update the upsell based on the active tab
    this.updateUpsellForActiveTab()
  }

  // Add a new method to update the upsell based on the active tab
  updateUpsellForActiveTab() {
    if (!this.upsellPlans) return;
    
    // Check if any upsell has the always-one-time flag set to true
    const alwaysOneTime = Array.from(this.upsellPlans).some(
      plan => plan.getAttribute('data-always-one-time') === 'true'
    );
    
    if (alwaysOneTime) {
      // If always one-time is enabled, always show the one-time upsell regardless of tab
      this.upsellPlans.forEach(upsellPlan => {
        if(upsellPlan.getAttribute('data-plan-name-handle') === 'one-time') {
          upsellPlan.classList.remove('hidden')
        } else {
          upsellPlan.classList.add('hidden')
        }
      });
    } else {
      // Regular behavior based on the active tab
      if (!this.tabId || this.tabId === 'subscription') {
        // For subscription tab, show the matching subscription upsell
        const planNameHandle = this.sell_plan.getAttribute('data-plan-name-handle');
        this.upsellPlans.forEach(upsellPlan => {
          if(upsellPlan.getAttribute('data-plan-name-handle') === planNameHandle) {
            upsellPlan.classList.remove('hidden')
          } else {
            upsellPlan.classList.add('hidden')
          }
        });
      } else {
        // For one-time tab, always show the one-time upsell
        this.upsellPlans.forEach(upsellPlan => {
          if(upsellPlan.getAttribute('data-plan-name-handle') === 'one-time') {
            upsellPlan.classList.remove('hidden')
          } else {
            upsellPlan.classList.add('hidden')
          }
        });
      }
    }
  }

  onClickTab(item) {
    this.tabId = item.getAttribute('data-id')
    this.tabs.forEach(tab => {
      if(this.tabId === tab.getAttribute('data-id')) {
        tab.setAttribute('aria-selected', true)
        tab.setAttribute('data-state', 'active')
      } else {
        tab.setAttribute('aria-selected', false)
        tab.setAttribute('data-state', 'inactive')
      }
    })
    
    if(this.tabId === 'subscription') {
      this.querySelector('[data-id="subscription"]').querySelector('div').classList.add('active')
      this.querySelector('[data-id="one-time"]').querySelector('div').classList.remove('active')

      this.querySelector('[options-subscription]').classList.add('display-contents')
      this.querySelector('[options-subscription]').classList.remove('hidden')
      this.querySelector('[options-onetime]').classList.remove('display-contents')
      this.querySelector('[options-onetime]').classList.add('hidden')

      this.updateSellPlans()
    } else {
      this.querySelector('[data-id="subscription"]').querySelector('div').classList.remove('active')
      this.querySelector('[data-id="one-time"]').querySelector('div').classList.add('active')
      this.querySelector('[options-subscription]').classList.remove('display-contents')
      this.querySelector('[options-subscription]').classList.add('hidden')
      this.querySelector('[options-onetime]').classList.add('display-contents')
      this.querySelector('[options-onetime]').classList.remove('hidden')

      this.updateOnetime()
    }
    
    // Update the upsell based on the new tab
    this.updateUpsellForActiveTab()
  }

  updateSellPlans() {
    // Find first available sell plan for this dog size
    let foundAvailableOption = false;
    let firstOption = null;
    
    // Try to match the ordering ID from one-time selection if possible
    let matchingOneTimeOrderingId = this.onetime.getAttribute('data-ordering-id');
    
    this.sellPlans.forEach(sellPlan => {
      if(sellPlan.getAttribute('data-parent-id') === this.dog_size) {
        // Keep track of the first option
        if (firstOption === null) {
          firstOption = sellPlan;
        }
        
        // Since there's no explicit availability attribute for sell plans,
        // we'll assume non-hidden ones are available
        if(!sellPlan.classList.contains('hidden')) {
          // Try to find option with same ordering ID as one-time
          if (matchingOneTimeOrderingId && sellPlan.getAttribute('data-ordering-id') === matchingOneTimeOrderingId) {
            this.sell_plan = sellPlan;
            foundAvailableOption = true;
          } else if (!foundAvailableOption) {
            // If no match found yet, use this available option
            this.sell_plan = sellPlan;
            foundAvailableOption = true;
          }
        }
      }
    });
    
    // If no available option found, use the first option as fallback
    if (!foundAvailableOption && firstOption) {
      this.sell_plan = firstOption;
    }
    
    const selectedOrderingId = this.sell_plan.getAttribute('data-ordering-id');

    this.sellPlans.forEach(sellPlan => {
      let btn = sellPlan.querySelector('[role="button"]')
      if(sellPlan.getAttribute('data-parent-id') === this.dog_size) {
        sellPlan.classList.remove('hidden')
        if(sellPlan.getAttribute('data-ordering-id') === selectedOrderingId) {
          sellPlan.setAttribute('aria-selected', true)
          sellPlan.setAttribute('data-state', 'active')
          btn.classList.add('active')
        } else {
          sellPlan.setAttribute('aria-selected', false)
          sellPlan.setAttribute('data-state', 'inactive')
          btn.classList.remove('active')
        }
      } else {
        sellPlan.classList.add('hidden')
        sellPlan.setAttribute('aria-selected', false)
        sellPlan.setAttribute('data-state', 'inactive')
        btn.classList.remove('active')
      }
    })

    this.updateFormField(true)
    
    // Only update the upsell if the subscription tab is active
    if (!this.tabId || this.tabId === 'subscription') {
      this.updateUpsellForActiveTab();
    }
  }

  updateOnetime(isUpdateForm = true) {
    // Find first available one-time option for this dog size
    let foundAvailableOption = false;
    let firstOption = null;
    
    // First try to match the ordering ID from subscription if possible
    let matchingSellPlanOrderingId = this.sell_plan.getAttribute('data-ordering-id');
    
    this.onetimes.forEach(onetime => {
      if(onetime.getAttribute('data-parent-id') === this.dog_size) {
        // Keep track of the first option
        if (firstOption === null) {
          firstOption = onetime;
        }
        
        // Check if the variant is available by comparing with string "true"
        if(onetime.getAttribute('data-variant-available') === "true") {
          // Try to find option with same ordering ID as subscription
          if (matchingSellPlanOrderingId && onetime.getAttribute('data-ordering-id') === matchingSellPlanOrderingId) {
            this.onetime = onetime;
            foundAvailableOption = true;
          } else if (!foundAvailableOption) {
            // If no match found yet, use this available option
            this.onetime = onetime;
            foundAvailableOption = true;
          }
        }
      }
    });
    
    // If no available option found, use the first option as fallback
    if (!foundAvailableOption && firstOption) {
      this.onetime = firstOption;
    }
    
    const selectedOrderingId = this.onetime.getAttribute('data-ordering-id');

    this.onetimes.forEach(onetime => {
      let btn = onetime.querySelector('[role="button"]')
      if(onetime.getAttribute('data-parent-id') === this.dog_size) {
        onetime.classList.remove('hidden')
        if(onetime.getAttribute('data-ordering-id') === selectedOrderingId) {
          onetime.setAttribute('aria-selected', true)
          onetime.setAttribute('data-state', 'active')
          btn.classList.add('active')
        } else {
          onetime.setAttribute('aria-selected', false)
          onetime.setAttribute('data-state', 'inactive')
          btn.classList.remove('active')
        }
      } else {
        onetime.classList.add('hidden')
        onetime.setAttribute('aria-selected', false)
        onetime.setAttribute('data-state', 'inactive')
        btn.classList.remove('active')
      }
    });

    if(isUpdateForm) {
      this.updateFormField(false)
    }
    
    // Only update the upsell if the one-time tab is active
    if (this.tabId === 'one-time') {
      this.updateUpsellForActiveTab();
    }
  }

  onClickSellPlan(item) {
    this.sell_plan = item
    this.sellPlans.forEach(sellPlan => {
      let btn = sellPlan.querySelector('[role="button"]')
      if(sellPlan === item) {
        sellPlan.setAttribute('aria-selected', true)
        sellPlan.setAttribute('data-state', 'active')
        btn.classList.add('active')
      } else {
        sellPlan.setAttribute('aria-selected', false)
        sellPlan.setAttribute('data-state', 'inactive')
        btn.classList.remove('active')
      }
    })
    this.updateFormField(true)
    
    // Only update the upsell if the subscription tab is active
    if (!this.tabId || this.tabId === 'subscription') {
      this.updateUpsellForActiveTab();
    }
  }

  onClickOneTimeVariant(item) {
    this.onetime = item
    this.onetimes.forEach(oneTime => {
      let btn = oneTime.querySelector('[role="button"]')
      if(oneTime === item) {
        oneTime.setAttribute('aria-selected', true)
        oneTime.setAttribute('data-state', 'active')
        btn.classList.add('active')
      } else {
        oneTime.setAttribute('aria-selected', false)
        oneTime.setAttribute('data-state', 'inactive')
        btn.classList.remove('active')
      }
    })
    this.updateFormField(false)
    
    // Only update the upsell if the one-time tab is active
    if (this.tabId === 'one-time') {
      this.updateUpsellForActiveTab();
    }
  }

  updateFormField(isSubscription) {
    if(isSubscription) {
      this.querySelector('[name="id"]').value = this.sell_plan.getAttribute('data-variant-id')
      this.querySelector('[name="selling_plan"]').value = this.sell_plan.getAttribute('data-sell-plan-id')
    } else {
      this.querySelector('[name="id"]').value = this.onetime.getAttribute('data-variant-id')
      this.querySelector('[name="selling_plan"]').value = ''
    }
    this.updateTotalPrice();
  }

  onClickAccordion(item) {
    const answer = item.parentElement.querySelector('[accordion-content')
    if(answer.hasAttribute('hidden')) {
      answer.removeAttribute('hidden')
      answer.setAttribute('data-state', 'open')
      this.setAttribute('aria-expanded', 'true')
      item.parentElement.setAttribute('data-state', 'open')
    } else {
      answer.setAttribute('data-state', 'close')
      answer.setAttribute('hidden', '')
      this.setAttribute('aria-expanded', 'false')
      item.parentElement.setAttribute('data-state', 'close')
    }
  }

  onModalTrigger() {
    const modalId = this.modalTrigger.getAttribute('modal-id')
    document.querySelector(modalId).classList.add('Modal__Overlay--after-open')
  }

  onClickUpsellSwitch() {
    // Guard check in case upsellSwitch doesn't exist
    if (!this.upsellSwitch) return;

    const innerSwitch = this.upsellSwitch.querySelector('div')
    if(this.upsellSwitch.classList.contains('upsell-switch-active')) {
      this.upsellSwitch.classList.remove('upsell-switch-active')
      this.upsellSwitch.setAttribute('aria-checked', 'false')
      if (innerSwitch) innerSwitch.removeAttribute('aria-checked')
    } else {
      this.upsellSwitch.classList.add('upsell-switch-active')
      this.upsellSwitch.setAttribute('aria-checked', 'true')
      if (innerSwitch) innerSwitch.setAttribute('aria-checked', 'true')
    }
    this.updateTotalPrice();
  }
  
  updateTotalPrice() {
    // Get the total span element
    const totalSpan = this.addToCartCTA.querySelector('.total');
    
    // Initialize total price
    let totalPrice = 0;
    
    // Get price from the active product option
    let priceElement = null;
    
    // Use direct references to the selected items when possible
    if (!this.tabId || this.tabId === 'subscription') {
      // For subscription tab, use direct reference to sell_plan
      if (this.sell_plan) {
        const sellPlanBtn = this.sell_plan.querySelector('.product-option-btn');
        if (sellPlanBtn) {
          priceElement = sellPlanBtn.querySelector('.option-name-price .option-price .price');
        }
      }
      
      // Fallbacks if direct reference doesn't work
      if (!priceElement) {
        // Try to find the active sell plan
        const activeSellPlan = this.querySelector('[product-sell-plan][aria-selected="true"]:not(.hidden)');
        if (activeSellPlan) {
          priceElement = activeSellPlan.querySelector('.option-name-price .option-price .price');
        }
      }
      
      // Last resort fallback
      if (!priceElement) {
        const firstVisibleSellPlan = this.querySelector('[product-sell-plan]:not(.hidden)');
        if (firstVisibleSellPlan) {
          priceElement = firstVisibleSellPlan.querySelector('.option-name-price .option-price .price');
        }
      }
    } else {
      // For one-time tab, use direct reference to onetime
      if (this.onetime) {
        const onetimeBtn = this.onetime.querySelector('.product-option-btn');
        if (onetimeBtn) {
          priceElement = onetimeBtn.querySelector('.option-name-price .option-price .price');
        }
      }
      
      // Fallbacks if direct reference doesn't work
      if (!priceElement) {
        // Try to find the active one-time option
        const activeOneTime = this.querySelector('[product-one-time-order][aria-selected="true"]:not(.hidden)');
        if (activeOneTime) {
          priceElement = activeOneTime.querySelector('.option-name-price .option-price .price');
        }
      }
      
      // Last resort fallback
      if (!priceElement) {
        const firstVisibleOneTime = this.querySelector('[product-one-time-order]:not(.hidden)');
        if (firstVisibleOneTime) {
          priceElement = firstVisibleOneTime.querySelector('.option-name-price .option-price .price');
        }
      }
    }
    
    // Extract the product price
    if (priceElement && priceElement.textContent) {
      const priceText = priceElement.textContent.trim();
      const priceValue = this.extractPriceValue(priceText);
      totalPrice += priceValue;
    }
    
    // Add upsell price if upsell is active
    if (this.upsellSwitch && this.upsellSwitch.classList.contains('upsell-switch-active')) {
      // First get the current tab ID to determine which upsell plan to check
      const upsellPlanSelector = !this.tabId || this.tabId === 'subscription' 
        ? `[upsell-plan][data-plan-name-handle="${this.sell_plan?.getAttribute('data-plan-name-handle') || ''}"]` 
        : '[upsell-plan][data-plan-name-handle="one-time"]';
      
      // Try to find the correct upsell plan first
      let upsellPriceElement = null;
      const matchingUpsellPlan = this.querySelector(upsellPlanSelector);
      
      if (matchingUpsellPlan) {
        // Try multiple selectors to find the price
        upsellPriceElement = matchingUpsellPlan.querySelector('.upsell-plan-price .upsell-price p');
        
        if (!upsellPriceElement) {
          // Alternative selector if the first one fails
          upsellPriceElement = matchingUpsellPlan.querySelector('.upsell-price p');
        }
        
        if (!upsellPriceElement) {
          // Even more generic selector as last resort
          upsellPriceElement = matchingUpsellPlan.querySelector('p:contains("$")');
        }
      }
      
      // If still no upsell price found, try any visible upsell plan
      if (!upsellPriceElement) {
        const visibleUpsellPlan = this.querySelector('[upsell-plan]:not(.hidden)');
        if (visibleUpsellPlan) {
          upsellPriceElement = visibleUpsellPlan.querySelector('.upsell-plan-price .upsell-price p');
          
          if (!upsellPriceElement) {
            upsellPriceElement = visibleUpsellPlan.querySelector('.upsell-price p');
          }
        }
      }
      
      // Extract the upsell price
      if (upsellPriceElement && upsellPriceElement.textContent) {
        const upsellPriceText = upsellPriceElement.textContent.trim();
        const upsellPriceValue = this.extractPriceValue(upsellPriceText);
        totalPrice += upsellPriceValue;
      }
    }
    
    // Format the total price and update the total in the add to cart button
    const formattedTotal = this.formatMoney(totalPrice);
    totalSpan.textContent = formattedTotal;
  }
  
  // Helper function to extract price value from text (e.g., "$19.99" to 1999)
  extractPriceValue(priceText) {
    // Remove currency symbol, commas, and any non-numeric characters except decimal point
    const numericString = priceText.replace(/[^0-9.]/g, '');
    
    // Convert to cents (multiplying by 100 to handle decimals)
    // Use Math.round to handle floating point precision issues
    const cents = Math.round(parseFloat(numericString) * 100);
    return cents;
  }
  
  // Format money value (cents) to currency string
  formatMoney(cents) {
    // Ensure we're working with a properly rounded integer value
    const value = Math.round(cents);
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    
    return formatter.format(value / 100);
  }
}

customElements.define('product-main', ProductMain);